/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, November 11th 2021, 10:54:17 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { TextFormInput, TextFormInputProps } from "ui-widgets/forms/input-fields/TextFormInput";

export const TextAreaFormInput = <T,>(props: TextFormInputProps<T>) => {
  return <TextFormInput {...props} multiline rows={props.rows ?? 4} />;
};
